/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";
import { API_URL } from "../utils/config";
import { getToken, getWrapperToken } from "../utils/helpers/auth";
import { _exists } from "../utils/helpers/common";
import get from "lodash/get";
import { client, client_BE, client_MO } from "./apollo";
//import { notification } from "antd";
//import { refreshToken } from "./refreshToken";
import { autoLogout } from "./autoLogout";
import { useNavigate } from "react-router-dom";
//import { useAuthCheck } from "../components/CustomHooks/useAuthCheck";
//import { useAuth } from "react-oidc-context";

export async function newRequest({
  method,
  url,
  data, // rest data or grapghql payload
  dataQuery, // graphql query string
  headers,
  auth,
  callType,
  callMethod,
  params,
  clientType,
  signal,
}: // getQuery,
any) {
  const token = getToken();
  const wrapperToken = getWrapperToken();
  headers = { ...headers };
  if (token) {
    headers = {
      ...headers,
      Authorization: "Bearer " + token,
      "Wrapper-Token": wrapperToken,
    };
  }

  if (callType === "axios") {
    url = API_URL + url; // combination of base_url + endpoint

    const response = await axios({
      method,
      url,
      headers,
      data,
      auth,
      params,
    }).catch(({ response }) => {
      //const { logout } = useAuthCheck();
      const navigate = useNavigate();

      if (get(response, "status", "") === 503) {
        navigate("/error-screen?type=503");
      } else if (get(response, "status", "") === 404) {
        navigate("/error-screen?type=404");
      }
      if (
        get(response, "status", "") === 401
        // &&
        // (get(response, "data.error.message", "") === "token is expired" ||
        //   get(response, "data.data.message", "") === "token is expired")
      ) {
        autoLogout();
        //refreshToken();
        //const authLib = useAuth();

        // notification.warning({
        //   message: "Session Expired",
        //   description: "Token is Expired!. Please log in...",
        //   duration: 2,
        //   onClose: () => {
        //     logout();
        //   },
        // });
        return;
      }
      if (
        response?.data?.errorMessage !== null &&
        _exists(response, "data.errorMessage")
      ) {
        return Promise.reject(response);
      }

      return { data: response.data ? response.data : {} };
    });
    return response;
  }

  if (callType === "apollo") {
    // for query
    if (callMethod === "query") {
      if (clientType === "MO") {
        try {
          const response = await client_MO.query({
            query: dataQuery,
            variables: data,
            fetchPolicy: "network-only",
            context: {
              fetchOptions: {
                signal: signal,
              },
            },
          });
          return response;
        } catch (error) {
          return Promise.reject(error);
        }
      }
      if (clientType === "BE") {
        try {
          const response = await client_BE.query({
            query: dataQuery,
            variables: data,
            fetchPolicy: "network-only",
            context: {
              fetchOptions: {
                signal: signal,
              },
            },
          });
          return response;
        } catch (error) {
          return Promise.reject(error);
        }
      }
      try {
        const response = await client.query({
          query: dataQuery,
          variables: data,
          fetchPolicy: "network-only",
          context: {
            fetchOptions: {
              signal: signal,
            },
          },
        });
        return response;
      } catch (error) {
        return Promise.reject(error);
      }
    }

    // for mutation
    if (callMethod === "mutation") {
      if (clientType === "MO") {
        try {
          const response = await client_MO.mutate({
            mutation: dataQuery,
            variables: data,
            context: {
              fetchOptions: {
                signal: signal,
              },
            },
            // refetchQueries: [{query: getQuery}]
          });
          return response;
        } catch (error) {
          return Promise.reject(error);
        }
      }
      if (clientType === "BE") {
        try {
          const response = await client_BE.mutate({
            mutation: dataQuery,
            variables: data,
            // refetchQueries: [{query: getQuery}]
            context: {
              fetchOptions: {
                signal: signal,
              },
            },
          });
          return response;
        } catch (error) {
          return Promise.reject(error);
        }
      }
      try {
        const response = await client.mutate({
          mutation: dataQuery,
          variables: data,
          // refetchQueries: [{query: getQuery}]
          context: {
            fetchOptions: {
              signal: signal,
            },
          },
        });
        return response;
      } catch (error) {
        return Promise.reject(error);
      }
    }
  }
}

//  To update the Cache
export async function UpdateCacheFunc({
  getQuery, // to fetch data from grapghql
  cachePayload, // data to be added to cache
  item, // graphql query function name
}: any) {
  try {
    const cachedData = client.readQuery({ query: getQuery });

    if (!cachedData) {
      console.error("Cached data not found");
      return;
    }
    const updatedChachedData = [...cachedData[item], cachePayload];
    // Write the updated data back to the cache
    client.writeQuery({
      query: getQuery,
      data: { [item]: updatedChachedData },
    });
  } catch (error) {
    console.error(error);
  }
}

export function pending(type: string) {
  return `${type}_PENDING`;
}

export function fulfilled(type: string) {
  return `${type}_FULFILLED`;
}
